import React from "react"

import ProjectComponent from "./project-component"

import PPIInvestmentProjectService from '../../../../service/sfp/ppi-investment-project-service'
import PPIInvestmentProjectGrantService from '../../../../service/sfp/ppi-investment-project-grant-service'

import PPIInvestmentProjectYearService from '../../../../service/sfp/ppi-investment-project-year-service'
import PPIInvestmentProjectGrantYearService from '../../../../service/sfp/ppi-investment-project-grant-year-service'

import TableDefinition from './project-table-definition'
import { resolveFctvaRetrieve } from '../../../../domain/sfp/ppi-domain'

class ProjectContainer extends React.Component {

	render() {

		return (
			<ProjectComponent
				current_year={this.props.current_year}
				ppi={this.props.ppi}
				project={this.props.project}
				theme={this.props.theme}
				subtheme={this.props.subtheme}
				data={this._getData()}
				tableDefinition={TableDefinition(this.props.project, this.props.theme, this.props.subtheme)}
				onCustomAction={this.props.onCustomAction}
				onChange={this._handleProjectChange.bind(this)}
				onProjectUpdated={this.props.onProjectUpdated}
			/>
		)
	}

	_getData() {
		const def = TableDefinition(this.props.project, this.props.theme, this.props.subtheme)
		var data = new Array(def.rows.length)
		var value, rest, budget
		const ppi = this.props.ppi
		def.rows.map(row => {
			data[row.index] = new Array(ppi.years.filter(y => y.year >= this.props.current_year).length)
			this.props.project.years.filter(y => (y.year >= this.props.current_year)).map((year, index) => {
				value = year[row.property]

				if (row.func) {
					value = row.func(this.props.project, year.year, ppi)
				}

				if (row.mapping) {
					value = row.mapping[value]
				}

				data[row.index][index] = value
			})

			budget = ""
			rest = ""
			switch(row.index) {
				case def.AMOUNT.index:
					rest = 0
					this.props.project.years.map(y => {
						rest += (y.amount ? y.amount : 0)
					})
					rest = this.props.project.budget - rest
					rest = (rest == 0 ? "" : rest)
					budget = this.props.project.budget || 0
					break
				case def.AWARDED_GRANTS.index:
				case def.ASKED_GRANTS.index:
					rest = 0
					budget = 0
					this.props.project.grants.filter(g => g.awarded == (row.index == def.AWARDED_GRANTS.index)).map(g => {
						budget += g.budget || 0
						g.years.map(y => {
						 rest += (y.amount ? y.amount : 0)
						})
					})
					rest = budget - rest
					break
				case def.NET_COST.index:
					budget = this.props.project.budget || 0
					this.props.project.grants.map(g => {
						budget -= g.budget || 0
					})
					budget -= this._getTotalFctva()
					break
				case def.FCTVA.index:
					budget = this._getTotalFctva()
					break
			}

			data[row.index].unshift(rest)
			data[row.index].unshift(budget)
			data[row.index].unshift(row.title)
		})

		return data
	}

	_reduceFctva(year) {
		var result = 0
		if (this.props.project.fctva) {
			var fctvaRetrieve
			var toRetrieve = this.props.ppi.years.filter(y => {
				fctvaRetrieve = resolveFctvaRetrieve(y, this.props.ppi)
				return (fctvaRetrieve + y.year) === year
			})
			toRetrieve.map(y => {
				if (year = this.props.project.years.find(py => py.year == y.year)) {
					result += year.amount * ((this.props.ppi.years.find(py => py.year == y.year).fctva || this.props.ppi.fctva) / 100)
				}
			})
		}
		return result
	}

	_getTotalFctva() {
		var result = 0
		this.props.ppi.years.map(y => {
			result += this._reduceFctva(y.year)
		})
		return result
	}

	_handleProjectChange = (
		owner,
		/** @type {CellInfo[]} */ cells,
		/** @type {String} */   source) => {
		if (cells && source !== "loadData" && source !== "populateFromArray") {
			const def = TableDefinition(this.props.project, this.props.theme, this.props.subtheme)
			var ppi = this.props.ppi
			var row, col, value, definition
			var project = this.props.project
			cells.map(cell => {
				row = cell[0]
				col = cell[1] - 2
				value = cell[3]
				value = (value == "") ? 0 : value
				switch(owner) {
					case "project":
						if (col == -1) {
							project.budget = value
							PPIInvestmentProjectService.updatePPIInvestmentProject(project.id, {"budget": project.budget})
						} else {
							col = col - 1 + this.props.ppi.years.filter(y => y.year < this.props.current_year).length
							definition = def.rows[row]
							if (definition.mapping) {
								value = Object.keys(definition.mapping).find(key => definition.mapping[key] === value)
							}
							if (definition.property) { 
								project.years[col][definition.property] = value
								PPIInvestmentProjectYearService.updatePPIInvestmentProjectYear(project.years[col].id, definition.property, value)
							}
						}
						break
					case "awarded_grants":
					case "asked_grants":
						var grant = this.props.project.grants.filter(g => g.awarded == (owner == "awarded_grants"))[row]
						if (col == -1) {
							grant.budget = value
							PPIInvestmentProjectGrantService.updatePPIInvestmentProjectGrant(grant.id, {budget: value})
						} else {
							col = col - 1 + this.props.ppi.years.filter(y => y.year < this.props.current_year).length
							var year = grant.years[col]
							year.amount = value
							PPIInvestmentProjectGrantYearService.updatePPIInvestmentProjectGrantYear(year.id, value)
						}
						break
				}
				this.setState({ppi}, () => {
					if (!project.theme) {
						const p = JSON.parse(JSON.stringify(project))
						if (this.props.subtheme) {
							p.theme = this.props.subtheme
							p.theme.parent = this.props.theme
						} else {
							p.theme = this.props.theme
						}
						this.props.onProjectUpdated(p)
					} else {
						this.props.onProjectUpdated(project)
					}
				})
			})
		}
	}

}

export default ProjectContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-container.js